import React from 'react';
import { Link } from 'react-router-dom';
import bilimagaci from '../assets/images/bilimagaci0.png';

const Hero: React.FC = () => {
  // Manifesto sayfasına giderken sayfayı en üste kaydırmak için
  const handleManifestoClick = () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  return (
    <div className="bg-gradient-to-r from-odtu-red to-odtu-dark-red text-white relative overflow-hidden">
      {/* Bilim Ağacı Arka Plan */}
      <div className="absolute right-0 top-0 h-full w-1/3 opacity-20 flex items-center justify-center">
        <img 
          src={bilimagaci} 
          alt="ODTÜ Bilim Ağacı" 
          className="h-full object-contain"
        />
      </div>
      
      <div className="container mx-auto px-4 py-16 md:py-24 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-10">
            <span className="block mb-2">Birlikte Daha Güçlüyüz</span>
            <span className="inline-flex items-center justify-center">
              ODTÜlüyüzBiz!
              <svg className="h-6 w-6 md:h-8 md:w-8 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            </span>
          </h1>
          <p className="text-lg md:text-xl mb-8">
            16 Mart 2025 tarihinde gerçekleşecek Seçimli Genel Kurul'da ODTÜlüyüzBiz ekibi olarak İstanbul ODTÜ Mezunları Derneği yönetimine adayız.          
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/manifesto" className="btn btn-primary" onClick={handleManifestoClick}>
              Manifestomuzu Okuyun
            </Link>
            <Link to="/candidates" className="btn btn-secondary">
              Aday Listemiz
            </Link>
          </div>
          
          <div className="mt-8 text-sm md:text-base bg-white/10 p-3 rounded-lg inline-block mx-auto">
            <p className="flex items-center justify-center">
              <svg className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>Adres: ODTÜPARK Ulus Mah. Adnan Saygun Cad. Budak Sok. No: 17 Ulus-Beşiktaş-İstanbul</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero; 